import { AppSidebar } from "@/components/app-sidebar";
import { Breadcrumb } from "@/components/breadcrumb";
import { Separator } from "@/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { STORAGE_KEYS } from "@/lib/constants";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { useUserStore } from "@/store/user";

export const Route = createFileRoute("/(authenticated)")({
  beforeLoad: async () => {
    const user = useUserStore.getState().user;
    const refreshUser = useUserStore.getState().refreshUser;
    if (!user) {
      await refreshUser().catch(() => {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        return redirect({ to: "/" });
      });
    }
    return { user };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-12 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear">
          <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
            <SidebarTrigger className="-ml-1" />
            <Separator
              orientation="vertical"
              className="mx-2 data-[orientation=vertical]:h-4"
            />
            <Breadcrumb />
          </div>
        </header>
        <main className="flex flex-1 flex-col gap-4 p-4">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
